// Modern CMI Utils integration - import direct
import {CmiUserUtils} from '@cmi/cmi-user-utils';

const user = document.getElementById('elle_identification_zone');

const profileLinkIds = ['Elle_header_id_ano', 'Elle_header_id_ano_bttm', 'Elle_header_id_connected_bttm', 'Elle_header_id_connected', 'Elle_header_id_ano_burger', 'Elle_header_id_connected_burger'];
if (profileLinkIds) {
    profileLinkIds.forEach((linkId) => {
        const profileLink = document.getElementById(linkId);
        if (profileLink) {
            profileLink.setAttribute("href", profileLink.getAttribute('data-href') + "?redirect_url=" + encodeURIComponent(document.documentURI) + "&oauth-path=login");
        }
    });
}

const pooolInit = window.POOOL_APP_ID || '';

const cmiParams = {
    env: window.ENV_DOMAIN || '',
    profile_url: window.PROFILE_URL || '',
    ws_url: window.PROFILE_WEBSERVICE_ORIGIN || '',
    log: ["*"],
    // AFTER MEP IS OK --> uncomment next line and delete previous line
    //log: window.APP_ENV === "prod" ? [] : ["*"],
    subscription_url: (window.ENV_DOMAIN || '') + "/Abonnement#xtatc=INT-44-[showcase]",
    premium: ""
};

const vendorParams = {
    poool: {
        init: pooolInit || '',
        options: {
            debug: window.APP_ENV !== 'prod',
            pianoAutoTrackingEnabled: true
        }
    }
};

const cmiUserUtils = new CmiUserUtils({
    ...cmiParams,
    vendor: vendorParams
});

const updateRefreshedUserStatus = () => {
    // Update tc_vars
    if (window.tc_vars) {
        window.tc_vars.user_nl = cmiUserUtils.user.nls ? cmiUserUtils.user.nls.toString() : null;
        window.tc_vars.user_type = cmiUserUtils.user.contentUserType;
        window.tc_vars.user_segment = cmiUserUtils.user.segment;
        window.tc_vars.user_id = cmiUserUtils.user.id;
    }
    updateUserStatus();
};

const updateUserStatus = () => {
    const headerMag = document.getElementById('header_mag');
    const footerMag = document.getElementById('footer_mag');

    if (cmiUserUtils.user.shouldBeLogged()) {
        if (user) {
            user.classList.add('user_connected');
            if (document.getElementById('elle_identification_zone_burger')) {
                document.getElementById('elle_identification_zone_burger').classList.add('user_connected');
            }
            if (document.getElementById('elle_identification_zone_bttm')) {
                document.getElementById('elle_identification_zone_bttm').classList.add('user_connected');
            }
        }

        if (cmiUserUtils.user.isPremium()) {
            let headerMagPremium = document.getElementById('header_mag_premium');
            let footerMagPremium = document.getElementById('footer_mag_premium');
            let footerGift = document.getElementById('Elle_EMPLACEMENT_gift_mobile');

            if (headerMagPremium) {
                headerMagPremium.classList.add('show_element');
            } else if (headerMag) {
                //si loggé mais elle à table ou deco
                headerMag.classList.add('show_element');
            }
            if (footerMagPremium) {
                footerMagPremium.classList.add('show_element');
                footerGift.style.right = '140px';
            } else if (footerMag) {
                //si loggé mais elle à table ou deco
                footerMag.classList.add('show_element');
            }

            if (cmiUserUtils.user.premiumStatus.indexOf('inapp') > -1) {
                if (document.getElementById('Elle_header_subscribe_mag_elle_2')) {
                    document.getElementById('Elle_header_subscribe_mag_elle_2').removeAttribute('data-target');
                    document.getElementById('Elle_header_subscribe_mag_elle_2').setAttribute('data-rel', btoa(Routing.generate('external_profile_myoffer_url')));
                }
                if (document.getElementById('Elle_header_subscribe_mag_elle_4')) {
                    document.getElementById('Elle_header_subscribe_mag_elle_4').removeAttribute('data-target');
                    document.getElementById('Elle_header_subscribe_mag_elle_4').setAttribute('data-rel', btoa('elle://magazine'));
                }
            }
        } else {
            if (headerMag) {
                headerMag.classList.add('show_element');
            }
            if (footerMag) {
                footerMag.classList.add('show_element');
            }

        }
    } else {
        if (headerMag) {
            headerMag.classList.add('show_element');
        }
        if (footerMag) {
            footerMag.classList.add('show_element');
        }
    }
};

cmiUserUtils.cmp().onReady(async () => {
    const pooolConsent = cmiUserUtils.cmp().hasConsent("c:poool-wtVRFZb9");

    await cmiUserUtils.user.ready();
    updateRefreshedUserStatus();

    const customFilters = [
        'page_content_class_' + (window.tc_vars && window.tc_vars.content_class ? window.tc_vars.content_class.toLowerCase().replace(' ', '_') : ''),
        'page_content_model_' + (window.tc_vars && window.tc_vars.content_model ? window.tc_vars.content_model.toLowerCase().replace(' ', '_') : ''),
        'page_content_tpl_' + (window.tc_vars && window.tc_vars.content_tpl ? window.tc_vars.content_tpl.toLowerCase().replace(' ', '_') : ''),
        'page_content_signature_' + (window.tc_vars && window.tc_vars.content_signature ? window.tc_vars.content_signature.toLowerCase().replace(' ', '_') : ''),
        'page_level_1_' + (window.tc_vars && window.tc_vars.level_1 ? window.tc_vars.level_1.toLowerCase().replace(' ', '_') : '')
    ];

    const customVariables = {
        'rubrique_name':  (globalThis.tc_vars && globalThis.tc_vars.level_1 ? globalThis.tc_vars.level_1.toLowerCase().replace(' ', '_') : '')
    };

    await cmiUserUtils.cdp().getAndStoreData();
    cmiUserUtils.engage().init(pooolConsent, customFilters, customVariables);

    document.addEventListener('cmi_user_on_is_logged', () => {
        updateUserStatus();
        updateRefreshedUserStatus();
    });
}, 0);
